// extracted by mini-css-extract-plugin
export default {"placeHolderShimmer":"v4UaFPynJQq4TECDb0xN"};